import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAppShellStore, useSessionStore } from '../../stores';

interface AuthGuardType {
  children: React.ReactNode;
}

// For routes that can only be accessed by authenticated account
function AuthGuard({ children }: AuthGuardType) {
  const isInitialized = useAppShellStore.use.isInitialized();
  const isAuthenticated = useSessionStore.use.isAuthenticated();

  if (isInitialized) {
    if (isAuthenticated) {
      return <>{children}</>;
    }
    return <Navigate to={'/auth/sign-in'} />;
  }
}

export default AuthGuard;
